import {useCallback} from 'react'
import {Button} from '@primer/react'
import {TriangleDownIcon} from '@primer/octicons-react'
import {LabelPicker, type LabelPickerLabel} from '@github-ui/item-picker-label-tsq'

interface DeferredFilterLabelsProps {
  owner: string
  repo: string
  selectedLabels: LabelPickerLabel[]
  labelsText: string
  onSelectionChange: (selected: LabelPickerLabel[]) => void
}

function DeferredFilterLabels({owner, repo, selectedLabels, labelsText, onSelectionChange}: DeferredFilterLabelsProps) {
  const handleSelectionChange = useCallback(
    (labels: LabelPickerLabel[]) => {
      onSelectionChange(labels)
    },
    [onSelectionChange],
  )

  return (
    <LabelPicker
      owner={owner}
      repo={repo}
      labels={selectedLabels}
      canCreateLabel={false}
      showColors={false}
      showEditLabelsButton={false}
      selectionVariant="multiple"
      onSelectionChange={handleSelectionChange}
      /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
      title="Select Labels"
      anchorElement={(anchorProps, ref) => (
        <Button ref={ref} trailingAction={TriangleDownIcon} {...anchorProps} aria-haspopup="dialog">
          <span className="color-fg-muted">Labels: </span>
          <span id="select-labels">{labelsText}</span>
        </Button>
      )}
    />
  )
}

export default DeferredFilterLabels
